// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1jglj","footer":"ModalUpdate_footer__nAWAW"};